import { useTranslations } from 'next-intl';

export const useHeaderNavLinks = () => {
  const t = useTranslations('navigation');

  return [
    {
      title: t('browse'),
      slug: '/courses',
    },
    {
      title: t('myClasses'),
      slug: '/my-classes',
    },
    {
      title: t('myWebinars'),
      slug: '/my-webinars',
    },
    {
      title: t('ieltsMocks'),
      slug: '/ielts-mock',
    },
  ];
};
